import { DepartmentValues } from './types';

export const DEPARTMENT_VALUES: DepartmentValues = {
 name:null,
  description: null,
  _rowTimestamp:null
};
